<template>
  <collapsible-section title="PIM_PRODUCT-ACCORDION_TITLE-NOTES" :defaultOpen="defaultOpen">

    <div
      :class="['item', { 'is-expanded': isEditorExpanded(note) }]"
      v-for="note in notes"
      :key="note"
    >
      <div class="control editor-toggle-label" @click="toggleEditor(note)">
        <div class="control-label">
          <label-name
            :labelKey="'PIM-PRODUCT-' + note.toUpperCase()"
          ></label-name>
        </div>
        <span class="material-symbols-outlined toggle-icon">
          {{ isEditorExpanded(note) ? 'expand_less' : 'expand_more' }}
        </span>
      </div>

      <div v-show="isEditorExpanded(note)">
        <div class="control froalaRTE froalaPlain">
          <froala
            id="froala"
            ref="froala"
            :tag="'textarea'"
            :config="{ ...froalaConfig, heightMin: 100 }"
            v-model="product[note].pim"
          ></froala>
        </div>

        <product-field
          :product="product"
          :property="note"
          :froalaConfig="froalaConfig"
        />
      </div>
    </div>


    <!-- Pflichtfeld -->
    <!-- Lagerungshinweis -->
    <div :class="['item', { 'is-expanded': isEditorExpanded('mandatoryDetails') }]">
      <div class="control editor-toggle-label" @click="toggleEditor('mandatoryDetails')">
        <div class="control-label">
          <label-name
            :labelKey="'PIM-PRODUCT-MANDATORY_DETAILS'"
          ></label-name>
        </div>
        <span class="material-symbols-outlined toggle-icon">
          {{ isEditorExpanded('mandatoryDetails') ? 'expand_less' : 'expand_more' }}
        </span>
      </div>

      <div v-show="isEditorExpanded('mandatoryDetails')">
        <div class="control froalaRTE froalaPlain">
        <froala
          id="froala2"
          ref="froala2"
          :tag="'textarea'"
          :config="{ ...froalaConfig, heightMin: 100 }"
          v-model="product.mandatoryDetails"
        ></froala>
        </div>

      </div>
    </div>

    <!-- Nährwerttabelle -->
    <div :class="['item', { 'is-expanded': isEditorExpanded('nutritionalInfo') }]">

       <div class="control editor-toggle-label" @click="toggleEditor('nutritionalInfo')">
         <div class="control-label">
           <label-name
           :labelKey="'PIM-PRODUCT-NUTRITIONAL_INFO'"
           ></label-name>
          </div>
          <span class="material-symbols-outlined toggle-icon">
            {{ isEditorExpanded('nutritionalInfo') ? 'expand_less' : 'expand_more' }}
          </span>
        </div>
        
        <div v-show="isEditorExpanded('nutritionalInfo')">
          <div class="control froalaRTE froalaPlain">
            <froala
              id="froala1"
              ref="froala1"
              :tag="'textarea'"
              :config="{ ...froalaConfig, heightMin: 100 }"
              v-model="product.nutritionalInfo"
            ></froala>
          </div>
          
        </div>
    </div>

    <!-- Lagerungshinweis -->
    <div :class="['item', { 'is-expanded': isEditorExpanded('storageInstructions') }]">
      <div class="control editor-toggle-label" @click="toggleEditor('storageInstructions')">
        <div class="control-label">
          <label-name
            :labelKey="'PIM-PRODUCT-STORAGE_INSTRUCTIONS'"
          ></label-name>
        </div>
        <span class="material-symbols-outlined toggle-icon">
          {{ isEditorExpanded('storageInstructions') ? 'expand_less' : 'expand_more' }}
        </span>
      </div>

      <div v-show="isEditorExpanded('storageInstructions')">
        <div class="control froalaRTE froalaPlain">
        <froala
          id="froala2"
          ref="froala2"
          :tag="'textarea'"
          :config="{ ...froalaConfig, heightMin: 100 }"
          v-model="product.storageInstructions"
        ></froala>
        </div>

      </div>
    </div>



  </collapsible-section>
</template>

<script>
import CollapsibleSection from "../../utils/CollapsibleSection.vue";
import productField from "../Product-Tab-Detail-Field.vue";

export default {
  name: "ProductSectionNotes",

  components: {
    CollapsibleSection,
    productField,
  },

  props: {
    product: { type: Object, required: true },
    froalaConfig: { type: Object, default: null },
    notes: { type: Array, required: true },
    defaultOpen: { type: Boolean, default: false },
  },

  data() {
    return {
      expandedEditors: {}
    };
  },

  methods: {
    toggleEditor(key) {
      this.expandedEditors = {
        ...this.expandedEditors,
        [key]: !this.expandedEditors[key]
      };
    },
    isEditorExpanded(key) {
      return !!this.expandedEditors[key];
    }
  }
};
</script>

<style scoped lang="scss">

.item {
  margin-bottom: 12px;
  transition: margin-bottom 0.2s ease;

  &.is-expanded {
    margin-bottom: 36px;
  }
}
.editor-toggle-label {
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
  width: 100%;

  .control-label {
    margin-bottom: 0;
    display: flex;
    align-items: center;
    line-height: 1;
  }
}

.toggle-icon {
  margin-left: 6px;
  font-size: 18px;
  color: #888;
  display: flex;
  align-items: center;
  line-height: 1;
}

.froalaRTE {
  margin-bottom: 8px;
  ::v-deep .fr-view {
    word-wrap: normal;
    white-space: normal;

    ul {
      display: block;
      border: none;
      margin-bottom: 15px;
      list-style-type: disc;
      list-style-position: outside;

      li {
        display: list-item;
      }
    }

    h1,
    h2,
    h3,
    h4 {
      all: revert;
    }
  }
}
</style>
